import { render, staticRenderFns } from "./BubbleSettings.vue?vue&type=template&id=7508c759&scoped=true"
import script from "./BubbleSettings.vue?vue&type=script&lang=js"
export * from "./BubbleSettings.vue?vue&type=script&lang=js"
import style0 from "./BubbleSettings.vue?vue&type=style&index=0&id=7508c759&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7508c759",
  null
  
)

export default component.exports